import { Appointment } from '@/app/appointment/entities/appointment.entity'

export interface AppointmentState {
    appointments: Appointment[]
}

export const state: AppointmentState = {
    appointments: []
}
